import api from '../api';

export interface TipoPergunta {
    id: string;
    nome: string;
}

export const getAllTipoPergunta = () => api.get<TipoPergunta[]>('tipoPerguntas');

export const Get = (id: string) => api.get('tipoPerguntas/${id}');
export const getAllTipoPerguntasOptions = () => getAllTipoPergunta().then(tipoPerguntas => (tipoPerguntas || []).map(t => ({ text: t.nome, value: t.id.toString() })))